interface IconProps {
  color?: string;
}

export function IconHome({ color = "currentColor" }: IconProps) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable={false}>
      <path
        d="M2.5 7.5L10 1.667L17.5 7.5V17.5H12.5V12.5H7.5V17.5H2.5V7.5Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function IconChat({ color = "currentColor" }: IconProps) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable={false}>
      <path
        d="M17.5 9.167C17.5 12.849 14.142 15.833 10 15.833C8.963 15.833 7.976 15.634 7.083 15.275L2.5 16.667L3.896 12.692C3.028 11.663 2.5 10.469 2.5 9.167C2.5 5.485 5.858 2.5 10 2.5C14.142 2.5 17.5 5.485 17.5 9.167Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function IconCRM({ color = "currentColor" }: IconProps) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable={false}>
      <circle cx="7.5" cy="6.667" r="3.333" stroke={color} strokeWidth="1.5" />
      <path
        d="M1.667 17.5C1.667 14.278 4.278 11.667 7.5 11.667C10.722 11.667 13.333 14.278 13.333 17.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <circle cx="14.167" cy="6.667" r="2.5" stroke={color} strokeWidth="1.5" />
      <path
        d="M17.5 17.5C17.5 15.015 16.023 12.869 13.893 11.874"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function IconSettings({ color = "currentColor" }: IconProps) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable={false}>
      <path
        d="M8.60417 3.5975C8.95917 2.13417 11.0408 2.13417 11.3958 3.5975C11.5039 4.04338 11.8184 4.41085 12.2422 4.58645C12.6661 4.76206 13.1483 4.72467 13.54 4.48583C14.8258 3.7025 16.2983 5.17417 15.515 6.46083C15.2765 6.85238 15.2392 7.33423 15.4146 7.75782C15.59 8.1814 15.957 8.49583 16.4025 8.60417C17.8658 8.95917 17.8658 11.0408 16.4025 11.3958C15.9566 11.5039 15.5891 11.8184 15.4135 12.2422C15.2379 12.6661 15.2753 13.1483 15.5142 13.54C16.2975 14.8258 14.8258 16.2983 13.5392 15.515C13.1476 15.2765 12.6658 15.2392 12.2422 15.4146C11.8186 15.59 11.5042 15.957 11.3958 16.4025C11.0408 17.8658 8.95917 17.8658 8.60417 16.4025C8.49613 15.9566 8.18164 15.5891 7.75779 15.4135C7.33394 15.2379 6.85172 15.2753 6.46 15.5142C5.17417 16.2975 3.70167 14.8258 4.485 13.5392C4.72349 13.1476 4.76079 12.6658 4.58539 12.2422C4.41 11.8186 4.04298 11.5042 3.5975 11.3958C2.13417 11.0408 2.13417 8.95917 3.5975 8.60417C4.04338 8.49613 4.41085 8.18164 4.58645 7.75779C4.76206 7.33394 4.72467 6.85172 4.48583 6.46C3.7025 5.17417 5.17417 3.70167 6.46083 4.485C7.29083 4.99167 8.37417 4.54333 8.60417 3.5975Z"
        stroke={color}
        strokeWidth="1.667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 10C12.5 11.3798 11.3798 12.5 10 12.5C8.62021 12.5 7.5 11.3798 7.5 10C7.5 8.62021 8.62021 7.5 10 7.5C11.3798 7.5 12.5 8.62021 12.5 10Z"
        stroke={color}
        strokeWidth="1.667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function IconLogout({ color = "currentColor" }: IconProps) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable={false}>
      <path
        d="M7.5 17.5H4.167A1.667 1.667 0 0 1 2.5 15.833V4.167A1.667 1.667 0 0 1 4.167 2.5H7.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.333 14.167L17.5 10L13.333 5.833"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M17.5 10H7.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function IconMenu({ color = "currentColor" }: IconProps) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable={false}>
      <path d="M2.5 5H17.5M2.5 10H17.5M2.5 15H17.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}

export function IconTeam({ color = "currentColor" }: IconProps) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable={false}>
      <circle cx="7" cy="6" r="2.5" stroke={color} strokeWidth="1.5" />
      <path
        d="M2 16.5C2 13.46 4.24 11 7 11C9.76 11 12 13.46 12 16.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <circle cx="13.5" cy="6.5" r="2" stroke={color} strokeWidth="1.5" />
      <path d="M18 16.5C18 14.01 16.21 12 14 12" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}

export function IconBilling({ color = "currentColor" }: IconProps) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable={false}>
      <rect x="2" y="5" width="16" height="11" rx="2" stroke={color} strokeWidth="1.5" />
      <path d="M2 9H18" stroke={color} strokeWidth="1.5" />
      <path d="M5.5 13H9" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}
